import { makeActionCreator } from '../../config/store/utils'
import { getTradedAmounts } from '../../services/contingencies'

export const GET_TRADED_AMOUNTS = 'GET_TRADED_AMOUNTS'
export const GET_TRADED_AMOUNTS_ERROR = 'GET_TRADED_AMOUNTS_ERROR'
export const GET_TRADED_AMOUNTS_SUCCESS = 'GET_TRADED_AMOUNTS_SUCCESS'
export const onGetTradedAmounts = makeActionCreator(GET_TRADED_AMOUNTS)
export const onGetTradedAmountsError = makeActionCreator(GET_TRADED_AMOUNTS_ERROR, 'payload')
export const onGetTradedAmountsSuccess = makeActionCreator(GET_TRADED_AMOUNTS_SUCCESS, 'payload')
export const onGetTradedAmountsThunk =
  ({ contingencyId, years }) =>
  async dispatch => {
    dispatch(onGetTradedAmounts())

    try {
      const { data } = await getTradedAmounts({ contingencyId, years })

      const chartStructure = data.payload.map(({ year, data: innerData }) => ({
        amount: innerData.map(({ amount }) => amount),
        amountUSD: innerData.map(({ amountUSD }) => amountUSD),
        month: innerData.map(({ month }) => month),
        name: year,
        orders: innerData.map(({ orders }) => orders),
        percentageAccumulative: innerData.map(({ percentAmountAcumCLP }) => percentAmountAcumCLP),
        percentageMonth: innerData.map(({ percentAmountMonthCLP }) => percentAmountMonthCLP),
        totalAmount: innerData.map(({ totalAmount }) => totalAmount),
        totalAmountUSD: innerData.map(({ totalAmountUSD }) => totalAmountUSD),
        totalOrders: innerData.map(({ ordersTotal }) => ordersTotal)
      }))

      const csvStructure = [
        ['Año', 'Mes', 'Monto por mes', 'Monto acumulado', 'Monto porcentual mensual', 'Monto porcentual acumulado'],
        ...chartStructure.flatMap(item =>
          item.amount.map((_, index) => [
            item.name,
            item.month[index],
            item.amount[index],
            item.totalAmount[index],
            item.percentageMonth[index],
            item.percentageAccumulative[index]
          ])
        )
      ]
      const payload = { chartStructure, csvStructure }

      return dispatch(onGetTradedAmountsSuccess(payload))
    } catch (error) {
      return dispatch(onGetTradedAmountsError({ error }))
    }
  }
